/* @flow */

import { css, plugins } from 'glamor';
import { withProps } from 'recompose';
import { has, mapValues } from 'lodash/fp';
import theme from './theme';

const mapValuesWithKey = mapValues.convert({ cap: false });

const generateClassNames = mapValuesWithKey((val, key) => {
  const glamorClassName = css(val).toString();
  return process.env.APP_ENV === 'production' ? glamorClassName : `${key} ${glamorClassName}`;
});

export function useGlamor(styling: (Theme) => Object) {
  const styles = styling(theme);
  const classes = generateClassNames(styles);

  return withProps({
    classes,
    sheet: { classes },
  });
}

export function glamorPlugins() {
  plugins.add(({ selector, style }) => ({
    selector,
    style: has('flexGrow', style) ? {
      ...style,
      WebkitBoxFlex: style.flexGrow,
    } : style,
  }));
}
